import Proxy from '../Proxy';

class StockItemProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stock', parameters);
  }

  amountAdd(id, data) {
    return this.submit('post', `stock/${id}/amount-add`, data);
  }

  amountReduce(id, data) {
    return this.submit('post', `stock/${id}/amount-reduce`, data);
  }

  amountReject(id, data) {
    return this.submit('post', `stock/${id}/amount-reject`, data);
  }

  amountRevoke(id, data) {
    return this.submit('post', `stock/${id}/amount-revoke`, data);
  }

  amountListing(id, data) {
    return this.submit('get', `stock/${id}/amount`, data);
  }

  eventsByCleanerListing(uuid) {
    return this.submit('get', `stock/cleaner/${uuid}`);
  }

  amountByCleanerListing(uuid) {
    return this.submit('get', `stock/cleaner-item/${uuid}`);
  }
}

export default StockItemProxy;
